import { useReactiveVar } from '@apollo/client';
import PropTypes from 'prop-types';
import React from 'react';
import currencyVar from '../../../apollo/reactive-variables/money';
import { DocumentList } from '../../../components/lists';
import FactoringHeader from '../../../components/headers/FactoringHeader';
import EVALUATING_FACTORING from '../../../graphql/queries/factoring/evaluating-factoring';
import useIsMobile from '../../../hooks/useIsMobile';
import {
  OUTSIDE_BOX_PROPS_FOR_HORIZONTAL_SCROLL,
  DETAILED_DATA_GRID_CLASS_NAME,
} from '../../../theme/constants/data-grid';
import EvaluationInvoiceFilters from '../components/filters/EvaluationInvoiceFilters';

const EVALUATION_REQUEST_STATUSES = [
  'Evaluating',
  'Rejected',
  'PendingDocuments',
  'DocumentsReviewed',
  'DocumentsReviewExpired',
];

const EvaluationInvoiceView = ({
  getColumns,
  includeHeaders,
  mobileHeaders,
  buttonsToShow,
  initialIssuedDate,
  additionalQueries,
  gridMinHeight,
  headerDescription,
  useBorderedTitle,
  OverlayComponent,
}) => {
  const isMobile = useIsMobile('tablet');
  const currency = useReactiveVar(currencyVar);

  return (
    <DocumentList
      trackerId="OFFERS"
      type="available-offers"
      headerTitle="Evaluaciones"
      CustomHeader={FactoringHeader}
      gridMinHeight={gridMinHeight}
      customHeaderProps={{
        Filters: EvaluationInvoiceFilters,
        useBorderedTitle,
        headerDescription,
      }}
      showFilters={false}
      queryDocument={EVALUATING_FACTORING}
      additionalQueries={additionalQueries}
      emitter
      includeHeaders={includeHeaders}
      mobileHeaders={mobileHeaders}
      mobileDensity="standard"
      rowHeight={65}
      customVariables={{
        currency,
        preoffer_Preofferevaluationrequest_Status_In: EVALUATION_REQUEST_STATUSES,
        dateIssued_Gte: initialIssuedDate,
        dateIssued_Lte: null,
        useCacheCount: false,
      }}
      preColumns={getColumns(isMobile)}
      dataGridClassName={DETAILED_DATA_GRID_CLASS_NAME}
      DataGridNoRowsOverlayComponent={OverlayComponent}
      outsideBoxProps={isMobile ? OUTSIDE_BOX_PROPS_FOR_HORIZONTAL_SCROLL : {}}
      defaultFilterProps={{
        showValidSiiCredentialsFilter: false,
        showLightningFilter: false,
        showPreoffersFilters: false,
        showStatesFilter: false,
        showDatesFilter: false,
        showRefresh: true,
        defaultFilterDays: null,
        showCompanyIssuerFilter: false,
        showQuickFilters: true,
        buttonsToShow,
      }}
    />
  );
};

EvaluationInvoiceView.propTypes = {
  getColumns: PropTypes.func.isRequired,
  includeHeaders: PropTypes.arrayOf(PropTypes.string),
  mobileHeaders: PropTypes.arrayOf(PropTypes.string),
  buttonsToShow: PropTypes.arrayOf(PropTypes.string),
  initialIssuedDate: PropTypes.string,
  additionalQueries: PropTypes.arrayOf(PropTypes.shape({})),
  gridMinHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  headerDescription: PropTypes.string,
  useBorderedTitle: PropTypes.bool,
  OverlayComponent: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
};

EvaluationInvoiceView.defaultProps = {
  includeHeaders: undefined,
  mobileHeaders: undefined,
  buttonsToShow: [],
  initialIssuedDate: undefined,
  additionalQueries: undefined,
  gridMinHeight: undefined,
  headerDescription: undefined,
  useBorderedTitle: false,
  OverlayComponent: undefined,
};

export default EvaluationInvoiceView;
